import { render, staticRenderFns } from "./ScratchCardReport.vue?vue&type=template&id=2db1c404&scoped=true"
import script from "./ScratchCardReport.vue?vue&type=script&lang=js"
export * from "./ScratchCardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1c404",
  null
  
)

export default component.exports